<div class="containerWrapper">

  <!-- Date range filters -->
  <div class="filters" style="display:flex; gap:12px; align-items:center; margin-bottom:12px;">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'Date range' | translate }}</mat-label>

      <!-- Required wrapper for start/end inputs -->
      <mat-date-range-input [rangePicker]="rangePicker">
        <input matStartDate [placeholder]="'From' | translate" [(ngModel)]="startDate" (dateChange)="applyDateRange()">
        <input matEndDate   [placeholder]="'To' | translate"   [(ngModel)]="endDate"   (dateChange)="applyDateRange()">
      </mat-date-range-input>

      <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
      <mat-date-range-picker #rangePicker></mat-date-range-picker>
    </mat-form-field>

    <button mat-stroked-button (click)="applyDateRange()">{{ 'Apply' | translate }}</button>
    <button mat-button (click)="clearDateRange()">{{ 'Clear' | translate }}</button>
  </div>

  <!-- Table -->
  <div class="tableWrapper" *ngIf="(dataSource?.data?.length ?? 0) > 0; else noOrdersTpl">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="project_id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Project ID' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ row.project_id }}</td>
      </ng-container>

      <ng-container matColumnDef="project_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Project Name' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ row.project_name || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="total_orders">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Total Orders' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ row.total_orders }}</td>
      </ng-container>

      <ng-container matColumnDef="total_value">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Total Value' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ row.total_value }}</td>
      </ng-container>

      <ng-container matColumnDef="currency">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Currency' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ row.currency }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator
      #paginator
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons>
    </mat-paginator>
  </div>

  <ng-template #noOrdersTpl>
    <p class="noOrders">{{ 'No orders in this period' | translate }}</p>
  </ng-template>
</div>

